import React from 'react';

/**
 * The definitions a report needs in order to be read correctly, kept out of the
 * way until asked for.
 *
 * These exist for a concrete reason: the fulfillment and reliability reports
 * slice by different dates and were reported as contradicting each other, and
 * the Vendor column routinely names a different company from the one that
 * cancelled. Left as loose <p> tags in .row_main_head they became columns
 * beside the title - that container is flex/space-between, built for
 * "heading left, button right" - and crowded the page.
 *
 * Native <details>: keyboard accessible, no state to manage, and it honours
 * reduced-motion for free.
 */
const ReportLegend = ({ lead, summary = 'How to read this report', items = [] }) => (
    <>
        {lead && <p className="report_lead">{lead}</p>}
        <details className="report_legend">
            <summary>{summary}</summary>
            <dl>
                {items.map(({ term, detail }) => (
                    <React.Fragment key={term}>
                        <dt>{term}</dt>
                        <dd>{detail}</dd>
                    </React.Fragment>
                ))}
            </dl>
        </details>
    </>
);

export default ReportLegend;
